import React from 'react'

const WeatherLoading = ({ loadingText }) => {
  return <div className="loader skeleton" tabIndex={0} aria-label={loadingText}></div>
}

export default WeatherLoading
